import { messages as e } from "@modules/locking-editor-ui-components";
//#region src/index.ts
var t = {
	messages: e,
	routes: []
};
//#endregion
export { t as lockingModule };

//# sourceMappingURL=index.es.js.map